module.exports = __webpack_public_path__ + "media/images/nurse-with-wrench-d8499ebfff8c0fe44212b6457c691c83.svg";